module.exports = __webpack_public_path__ + "static/media/225.033ff53b.svg";